<div class="sidenav-container">
    <!-- Fila compacta de caja: el punto late mientras la caja está abierta. -->
    <ng-container *ngIf="commerceService.commerce?.cashBox?.enabled">
        <!-- Envuelto en un objeto para que el *ngIf no oculte la fila cuando la caja está cerrada (false). -->
        <div class="cashbox-row" *ngIf="{ open: cashboxService.isCashboxOpen$ | async } as cashbox" [class.cashbox-row--open]="cashbox.open">
            <span class="cashbox-row__dot" [class.cashbox-row__dot--live]="cashbox.open"></span>
            <span class="cashbox-row__label">{{ cashbox.open ? 'Caja abierta' : 'Abrir caja' }}</span>
            <label class="cashbox-switch" [attr.aria-label]="cashbox.open ? 'Cerrar caja' : 'Abrir caja'">
                <input type="checkbox" [checked]="cashbox.open" (click)="onToggleSwitch($event)" />
                <span class="cashbox-switch__track"></span>
            </label>
        </div>
    </ng-container>
    <nav class="sidenav shadow-right menu pt-0 d-flex flex-column" id="sidenavAccordion" [ngClass]="sidenavStyle" data-cy="sideNav">
        <div class="sidenav-wrapper flex-grow-1">
            <div class="sidenav-menu">
                <!-- Gate de Nina: dueño del comercio + plan pago. -->
                <button type="button" class="btn-nina" *ngIf="ninaEnabled" [routerLink]="['/asistente']" (click)="onNinaCtaClick()">
                    <span class="mini-blob">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M12 3c.4 3.5 1.3 5.8 2.7 7.3C16.2 11.7 18.5 12.6 22 13c-3.5.4-5.8 1.3-7.3 2.7C13.3 17.2 12.4 19.5 12 23c-.4-3.5-1.3-5.8-2.7-7.3C7.8 14.3 5.5 13.4 2 13c3.5-.4 5.8-1.3 7.3-2.7C10.7 8.8 11.6 6.5 12 3Z"
                                fill="#fff"
                            />
                        </svg>
                    </span>
                    <span class="btn-nina__label">Preguntar a Nina</span>
                    <span class="btn-nina__badge">IA</span>
                </button>
                <div class="nav">
                    <ng-container *ngFor="let section of sideNavSections">
                        <div class="sidenav-menu-heading" *ngIf="section.text">{{ section.text }}</div>
                        <ng-container *ngFor="let item of section.items">
                            <sbpro-side-nav-item *ngIf="!isCreditosItem(sideNavItems[item])" [sideNavItem]="sideNavItems[item]"></sbpro-side-nav-item>
                        </ng-container>
                    </ng-container>
                </div>
            </div>

            <!-- Spacer que empuja Configuración al fondo. FINA-3378 (canvas «Box copy»): aloja Fina Presta
                 pegado abajo, con la línea gris arriba solo cuando el ítem se ve. -->
            <div class="flex-spacer" [class.sidenav-presta]="showPresta(user$ | async)" data-test="sidenav-presta-slot">
                <sbpro-side-nav-item *ngIf="prestaItem" [sideNavItem]="prestaItem"></sbpro-side-nav-item>
            </div>

            <div class="sidenav-menu config-menu">
                <div class="nav">
                    <div class="sidenav-menu-heading">{{ configSection.text }}</div>
                    <ng-container *ngFor="let item of configSection.items">
                        <sbpro-side-nav-item [sideNavItem]="sideNavItems[item]"></sbpro-side-nav-item>
                    </ng-container>
                </div>
            </div>
        </div>

        <ng-container *ngIf="user$ | async as user">
            <div class="sidenav-footer-1 flex-shrink-0">
                <button
                    *ngIf="user.permissions?.COMMERCE?.includes('create-and-edit-users')"
                    class="btn btn-info px-3 border-0 shadow-sm btn-crear-usuarios text-purple fw-bolder w-100"
                    (click)="openReferralsModal(); analyticsService.analyticsCapture('sidenav_Referidos button')"
                >
                    <img src="assets/icons/svg/referrals_icon.svg" class="me-2" />
                    <span>Invita y gana</span>
                </button>
                <button
                    *ngIf="user.permissions?.COMMERCE?.includes('create-and-edit-users')"
                    class="btn btn-info px-3 border-0 shadow-sm btn-crear-usuarios text-purple fw-bolder w-100"
                    [routerLink]="['/comercio/usuarios-asociados']"
                    (click)="analyticsService.analyticsCapture('sidenav_Crear usuarios button')"
                >
                    + Crear usuarios <span class="badge rounded-pill text-bg-success bg-success ms-2" *ngIf="!extraUsersSalesEnabled">Gratis</span>
                </button>
                <div class="sidenav-footer-user" [title]="'Registrado como ' + user.name + ' ' + user.lastName">
                    <fa-icon class="sidenav-footer-user__icon" [icon]="['fas', 'user']"></fa-icon>
                    <span class="sidenav-footer-user__name">{{ user.name }} {{ user.lastName }}</span>
                </div>
            </div>
        </ng-container>
    </nav>
</div>
